export const COMPASS_FAVORITES_KEY = "skillAgentCompassFavorites";

function normalizeFavorite(raw) {
  if (!raw || typeof raw !== "object") return null;
  const kind =
    raw.kind === "meeting"
      ? "meeting"
      : raw.kind === "project"
        ? "project"
        : null;
  if (!kind) return null;
  const id = Number(raw.id);
  if (!Number.isFinite(id) || id <= 0) return null;
  const projectId = Number(raw.projectId || (kind === "project" ? id : 0));
  if (!Number.isFinite(projectId) || projectId <= 0) return null;
  const label =
    String(raw.label || "").trim() ||
    (kind === "meeting" ? `Reunión #${id}` : `Proyecto #${id}`);
  const orgBrand = raw.orgBrand ? String(raw.orgBrand) : null;
  return orgBrand
    ? { kind, id, projectId, label, orgBrand }
    : { kind, id, projectId, label };
}

export function favoriteKey(fav) {
  if (!fav) return "";
  return `${fav.kind}:${Number(fav.id)}`;
}

export function parseCompassFavorites(raw) {
  let list = raw;
  if (typeof raw === "string") {
    try {
      list = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(list)) return [];
  const seen = new Set();
  const out = [];
  for (const row of list) {
    const fav = normalizeFavorite(row);
    if (!fav) continue;
    const key = favoriteKey(fav);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(fav);
  }
  return out;
}

export function serializeCompassFavorites(list) {
  return JSON.stringify(parseCompassFavorites(list));
}

export function isCompassFavorite(list, kind, id) {
  const want = `${kind}:${Number(id)}`;
  return (list || []).some((f) => favoriteKey(f) === want);
}

export function toggleCompassFavorite(list, entry) {
  const fav = normalizeFavorite(entry);
  if (!fav) return parseCompassFavorites(list);
  const current = parseCompassFavorites(list);
  const key = favoriteKey(fav);
  const idx = current.findIndex((f) => favoriteKey(f) === key);
  if (idx >= 0) {
    return current.filter((_, i) => i !== idx);
  }
  return [...current, fav];
}

function defaultStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function loadCompassFavorites(storage = defaultStorage()) {
  try {
    const raw = storage?.getItem?.(COMPASS_FAVORITES_KEY);
    return parseCompassFavorites(raw || "[]");
  } catch {
    return [];
  }
}

export function saveCompassFavorites(list, storage = defaultStorage()) {
  const next = parseCompassFavorites(list);
  try {
    storage?.setItem?.(COMPASS_FAVORITES_KEY, serializeCompassFavorites(next));
  } catch {
    /* ignore quota / private mode */
  }
  return next;
}

export function favoriteFromCompassNode(node) {
  if (!node) return null;
  if (node.kind === "project") {
    const projectId = Number(node.ProjectId || node.projectId);
    if (!Number.isFinite(projectId) || projectId <= 0) return null;
    return {
      kind: "project",
      id: projectId,
      projectId,
      label: String(node.label || `Proyecto #${projectId}`).trim(),
    };
  }
  if (node.kind === "meeting") {
    const id = Number(node.MeetingSessionId || node.meeting?.id);
    const projectId = Number(node.ProjectId || node.projectId);
    if (!Number.isFinite(id) || id <= 0) return null;
    if (!Number.isFinite(projectId) || projectId <= 0) return null;
    const orgBrand = node.OrgBrand || node.orgBrand || null;
    return {
      kind: "meeting",
      id,
      projectId,
      label: String(
        node.label || node.meeting?.title || `Reunión #${id}`,
      ).trim(),
      ...(orgBrand ? { orgBrand: String(orgBrand) } : {}),
    };
  }
  return null;
}
